<template>
  <footer class="footer">
    <div class="footer-content">
      <!-- Marca -->
      <div class="footer-section footer-brand">
        <h3>FUNARPEN</h3>
        <p>Fundo de Apoio ao Registro Civil de Pessoas Naturais</p>
      </div>

      <!-- Endereço -->
      <div class="footer-section footer-address">
        <h4>Endereço</h4>

        <p class="footer-line">
          <v-icon small>mdi-map-marker</v-icon>
          <span> Rua Marechal Deodoro, 252 - 2º andar Conj 201/202 - Curitiba/PR - 80010-010 </span>
        </p>

        <p class="footer-link-line">
          <a
            href="https://maps.app.goo.gl/MhXfpRECswjyGjgg6"
            target="_blank"
            rel="noopener"
          >
            Ver no Google Maps
          </a>
        </p>
      </div>

      <!-- Contato -->
      <div class="footer-section footer-contact">
        <h4>Contato</h4>

        <p class="footer-line">
          <v-icon small>mdi-phone</v-icon>
          <span>
            Telefone:
            <a href="tel:+554133041300">(41) 3304-1300</a>
          </span>
        </p>

        <p class="footer-line">
          <v-icon small>mdi-email</v-icon>
          <span>
            Email:
            <a href="mailto:funarpen@funarpen.com.br">funarpen@funarpen.com.br</a>
          </span>
        </p>
      </div>

      <!-- Suporte -->
      <div class="footer-section footer-support">
        <h4>Suporte</h4>

        <p class="footer-line">
          <v-icon small>mdi-remote-desktop</v-icon>
          <NuxtLink to="/funarpen/acesso-remoto"> Acesso Remoto </NuxtLink>
        </p>
      </div>

      <!-- Redes Sociais -->
      <div class="footer-section footer-social">
        <h4>Redes Sociais</h4>

        <p class="footer-line">
          <v-icon small>mdi-instagram</v-icon>
          <a
            href="https://instagram.com/funarpenpr"
            target="_blank"
            rel="noopener"
          >
            Instagram
          </a>
        </p>
      </div>

      <!-- Links -->
      <div class="footer-section footer-links">
        <nav>
          <a href="#">Política de Privacidade</a>
          <a href="#">Termos de Uso</a>
          <span>© {{ new Date().getFullYear() }} FUNARPEN - {{ version }}</span>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useRuntimeConfig } from '#imports'

const config = useRuntimeConfig()
const version = config.public.appVersion
</script>

<style scoped>
.footer {
  position: relative;
  z-index: 20;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  background: linear-gradient(135deg, #082f49, #0b4f6c), #082f49;
  padding: 28px clamp(16px, 4vw, 40px);
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.9rem;
}

.footer-content {
  width: min(100%, 1600px);
  margin: 0 auto;
  display: grid;
  grid-template-columns:
    minmax(180px, 0.85fr)
    minmax(250px, 1.55fr)
    minmax(250px, 1.15fr)
    minmax(150px, 0.7fr)
    minmax(150px, 0.7fr)
    minmax(190px, 0.85fr);
  gap: clamp(20px, 2.5vw, 40px);
  align-items: flex-start;
}

.footer-section {
  min-width: 0;
}

.footer-brand h3 {
  margin: 0 0 8px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 900;
}

.footer-brand p {
  max-width: 320px;
}

.footer-section h4 {
  margin: 0 0 10px;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
}

.footer-section p,
.footer-section a,
.footer-section span {
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.footer-section a:hover {
  color: #fff;
  text-decoration: none;
}

.footer-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px !important;
}

.footer-link-line {
  margin-top: 8px !important;
}

.footer-line .v-icon,
.v-icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #d7bd85;
}

.footer-contact .footer-line span,
.footer-support .footer-line a,
.footer-social .footer-line a,
.footer-links nav a,
.footer-links nav span {
  white-space: nowrap;
}

.footer-links nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* telas médias */
@media (max-width: 1280px) {
  .footer-content {
    grid-template-columns: 1.1fr 1.8fr 1.2fr;
    gap: 32px 40px;
  }

  .footer-links {
    grid-column: 1 / -1;
  }

  .footer-links nav {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
  }
}

/* tablet */
@media (max-width: 900px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 22px 28px;
  }

  .footer-links {
    grid-column: auto;
  }

  .footer-links nav {
    flex-direction: column;
    gap: 4px;
  }
}

/* mobile */
@media (max-width: 600px) {
  .footer {
    padding: 18px 16px;
    font-size: 0.86rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .footer-section h4 {
    margin-bottom: 4px;
    font-size: 0.95rem;
  }

  .footer-brand h3 {
    margin-bottom: 4px;
    font-size: 1rem;
  }

  .footer-brand p {
    max-width: none;
  }

  .footer-line {
    gap: 6px;
    margin-bottom: 4px !important;
  }

  .footer-link-line {
    margin-top: 4px !important;
  }

  .footer-section p,
  .footer-section a,
  .footer-section span {
    line-height: 1.35;
  }

  .footer-contact .footer-line span,
  .footer-social .footer-line a,
  .footer-links nav a,
  .footer-links nav span {
    white-space: normal;
  }

  .footer-links {
    display: block;
  }
}
</style>

